import { Condition } from '@medplum/fhirtypes';
import { MedplumClient } from '@medplum/core';
import { useGenericResourceSearch } from '@/hooks/useGenericResourceSearch';
import {
  CONDITION_SEARCH_DEFAULTS,
  conditionSearchConfig,
  type ConditionSearchParams,
} from './diagnosisSearchConfig';

export type { ConditionSearchParams };
export { CONDITION_SEARCH_DEFAULTS };

export function useConditionSearch(
  medplum: MedplumClient,
  patientId?: string
) {
  return useGenericResourceSearch<ConditionSearchParams, Condition>(
    medplum,
    conditionSearchConfig,
    patientId
  );
}

